export default "__VITE_ASSET__DVaT9WEc__"